"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // (C) 2007-2018 GoodData Corporation

/**
 * Return promise that will resolve after `ms` miliseconds
 *
 * @param {Number} ms time in miliseconds
 * @return {Promise}
 */

function delay(ms) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      return resolve();
    }, ms);
  });
}

exports.delay = delay;